import { Component } from '@angular/core';
import { BlogsComponent } from '@prekog/common-ui';
import { BlogEnum } from '../bloglist/blogEnum';

@Component({
    selector: 'app-smarties',
    templateUrl: './smarties.component.html',
    styleUrls: ['./smarties.component.scss'],
    standalone: true,
    imports: [BlogsComponent]
})
export class SmartiesComponent {
    type = BlogEnum.SMARTY;
}
